import React from 'react';
import styled from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import CreditPng from '@/assets/images/detailed-car-pdf/credit.png';
import AutoPng from '@/assets/images/detailed-car-pdf/auto.png';
import { colors, fonts } from '@/constants/theme';
import Picture from '@/components/Picture';

import CarPricePdf from '../CarPricePdf';

function PaymentInfo() {
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const { pricing } = data;

  return (
    <Component>
      {pricing?.price && (
        <PriceWrapper>
          <Label>{!pricing.discountPrice ? 'Цена' : 'Специальная цена'}</Label>
          <CarPricePdf
            amount={
              pricing.discountPrice ? pricing.discountPrice : pricing.price
            }
            discount={
              pricing.discountPrice &&
              pricing.price &&
              pricing.price - pricing.discountPrice
            }
          />
          <Text>
            Не является публичной офертой. Окончательную цену и комплектацию
            уточняйте у специалиста.
            <br /> Срок действия предложения ограничен.
          </Text>
        </PriceWrapper>
      )}
      <List>
        <ListItem>
          <Icon loading="lazy" src={CreditPng} />
          <ItemText>Возможна покупка в кредит/лизинг</ItemText>
        </ListItem>
        <ListItem>
          <Icon loading="lazy" src={AutoPng} />
          <ItemText>TRADE-IN</ItemText>
        </ListItem>
      </List>
    </Component>
  );
}

export default PaymentInfo;

const Component = styled.div`
  display: flex;
  margin: 50px 0;
  height: 131px;
`;

const PriceWrapper = styled.div<{
  hasPrice?: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.hasPrice ? 'center' : 'space-between')};
  border-right: 1px solid ${colors.gray};
  flex: 200px;
`;

const Label = styled.div`
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  color: ${colors.black};
  font-family: ${fonts.GrtskTera};
`;

const Text = styled.div`
  width: 217px;
  font-size: 8px;
  line-height: 12px;
  color: ${colors.black};
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 233px;
  padding-left: 35px;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 15px;
  }
`;

const Icon = styled(Picture)`
  width: 50px;
  heigth: 50px;
`;

const ItemText = styled.div`
  width: 200px;
  padding-left: 13px;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.black};
  font-family: ${fonts.GrtskTera};
  font-weight: 600;
`;
